import * as React from "react";
const SvgCheckmark20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 13,
        fill: "black",
        viewBox: "0 0 16 13"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M15.914 2 5.5 12.414.086 7 1.5 5.586l4 4 9-9L15.914 2Z",
      clipRule: "evenodd"
    })
  );
export default SvgCheckmark20Px;
